import script from "./HomepageSidebarFilterItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageSidebarFilterItem.vue?vue&type=script&setup=true&lang=js"

import "./HomepageSidebarFilterItem.vue?vue&type=style&index=0&id=e4c082de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4c082de"]])

export default __exports__